import { render, staticRenderFns } from "./SubProductTag.vue?vue&type=template&id=fb1a1114&"
import script from "./SubProductTag.vue?vue&type=script&lang=js&"
export * from "./SubProductTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports